export const PlayerFoulTypes = [
  "personal",
  "shooting",
  "offensive",
  "technical",
  "unsportsmanlike",
  "disqualifying",
  "throwIn",
  "double",
  "cancellation",
];

// When fixtureProfile.ruleSet is "FIBA":
// - the unsportsmanlike foul is replaced by a flagrant foul (identical behavior, different subType/label),
// - the technical foul is replaced by category 1 and category 2 technical fouls (identical behavior,
//   but only category 1 contributes to a player's automatic disqualification),
// - a disruptive foul becomes available, following the same workflow as flagrant but without
//   contributing to a player's automatic disqualification.
export const swapUnsportsmanlikeForFlagrant = (foulTypes) =>
  foulTypes.map((type) => (type === "unsportsmanlike" ? "flagrant" : type));

export const FlagrantRuleSetShowOn = { state: "fixtureProfile.ruleSet", value: "FIBA", operator: "is" };

export const UnsportsmanlikeRuleSetShowOn = { state: "fixtureProfile.ruleSet", value: "FIBA", operator: "not" };

export const FlagrantPlayerFoulTypes = [
  "personal",
  "shooting",
  "offensive",
  "categoryOneTechnical",
  "categoryTwoTechnical",
  "throwIn",
  "flagrant",
  "disruptive",
  "disqualifying",
  "double",
  "cancellation",
];

export const BenchFoulTypes = ["benchTechnical", "cancellation"];

export const CoachFoulTypes = ["coachTechnical", "coachDisqualifying", "cancellation"];

export const TechnicalFoulTypes = [
  "technical",
  "categoryOneTechnical",
  "categoryTwoTechnical",
  "benchTechnical",
  "coachTechnical",
];

export const CancellationPlayerFoulTypes = [
  "technical",
  "throwIn",
  // commenting out temporarily until we figure out how to handle foul drawn in this flow better
  // "unsportsmanlike",
  // "disqualifying",
];

export const FlagrantCancellationPlayerFoulTypes = ["categoryOneTechnical", "categoryTwoTechnical", "throwIn"];

export const CancellationCoachFoulTypes = ["coachTechnical", "coachDisqualifying"];

export const CancellationBenchFoulTypes = ["benchTechnical"];

export const CancellationDisqualifyingFoulTypes = [
  "unsportsmanlike",
  "flagrant",
  "disqualifying",
  "coachDisqualifying",
];

export const DoubleFoulTypes = ["personal", "unsportsmanlike", "disqualifying"];

export const FlagrantDoubleFoulTypes = swapUnsportsmanlikeForFlagrant(DoubleFoulTypes);
